import {
  Activity,
  Bot,
  Building2,
  Calendar,
  ChartColumn,
  Circle,
  CircleCheck,
  Contact,
  FileSpreadsheet,
  Gauge,
  Handshake,
  Headset,
  Inbox,
  LayoutGrid,
  LifeBuoy,
  Mail,
  PhoneCall,
  ScrollText,
  Settings,
  Users,
  Workflow,
  type LucideIcon,
} from 'lucide-react';
import type { ModuleDefinition } from '@/lib/modules';

/**
 * `modules.ts` names its icon as a string so the registry stays free of React.
 * This map is the one place that turns that name into a component, and the
 * fallback means an unknown name degrades to a dot instead of a blank nav row.
 */
const ICONS: Record<string, LucideIcon> = {
  Activity,
  Bot,
  Building2,
  Calendar,
  ChartColumn,
  CircleCheck,
  Contact,
  FileSpreadsheet,
  Gauge,
  Handshake,
  Headset,
  Inbox,
  LayoutGrid,
  LifeBuoy,
  Mail,
  PhoneCall,
  ScrollText,
  Settings,
  Users,
  Workflow,
};

export const moduleIcon = (module: ModuleDefinition): LucideIcon => ICONS[module.icon] ?? Circle;
